<template>
  <div class="navbar">
    <img class="navbar-logo" src="@/assets/web/navbar-logo.png" />
    <ul class="navbar-menus">
      <li @click="toMusic">音乐</li>
      <li @click="toColumn">频道栏目</li>
      <li @click="tomemberCenter">会员中心</li>
      <li @click="gotoHome">关于我们</li>
      <li @click="gotoContactUs">商务合作</li>
    </ul>
    <div class="user-info">
      <el-dropdown @command="handleuser" trigger="click" style="height:3.125vw">
        <span class="el-dropdown-link">
          <img class="user-logo" :src="user.avatar" v-if="isLogin" />
          <img class="user-logo" v-if="!user.avatar" src="../assets/web/login.png" />
          <span v-if="isLogin">{{user.nickName}}</span>
          <span v-if="!isLogin" @click="login">登录</span>
          <i v-if="isLogin" class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdownR" v-if="isLogin">
          <el-dropdown-item command="loginout">
            <img src="../assets/web/退出登录@2x.png" class="menueitem_icon2" />退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <login-dialog :dialog-visible="dialogVisible" ref="login"></login-dialog>
  </div>
</template>
<script>
import axios from "axios";
import loginDialog from "./loginDialog";
export default {
  components: { loginDialog },
  data() {
    return {
      index: 0,
      user: {},
      isLogin: false,
      dialogVisible: false,
      name: "",
    };
  },
  computed: {
    username() {},
  },
  created() {
    let openid = this.$route.query.uuid;
    if (openid) {
      localStorage.setItem("website_openid", openid);
    }
    let localopenid = localStorage.getItem("website_openid");
    if (localopenid) {
      this.isLogin = true;
    }
    // 页面刷新获取头部信息
    if (localopenid) {
      let url = "/official/user/load/" + localopenid;
      axios.get(url).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.user = res.data.data;
          localStorage.setItem("website_isMember", this.user.isMember);
        } else {
          if (res.status == 200) {
            this.$message.error(res.data.message);
          } else {
            this.$message.error("数据请求失败");
          }
        }
      });
    }
  },
  methods: {
    login() {
      this.dialogVisible = true;
      this.$refs.login.getqrcode();
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    gotoHome() {
      this.$router.push({ path: "/web" });
    },
    toColumn() {
      this.$router.push({ name: "column" });
    },
    gotoContactUs() {
      let anchor = this.$parent.$el.querySelector("#footer");
      if (anchor) {
        document.documentElement.scrollTop = anchor.offsetTop;
      } else {
        this.$router.push({ path: "/web", query: { isoffset: 1 } });
      }
    },
    toMusic() {
      this.$router.push({ path: "/music" });
    },
    handleuser(command) {
      if (command == "loginout") {
        localStorage.clear("website_openid");
        localStorage.clear("website_isMember");
        this.isLogin = false;
        this.user = {};
        let path = this.$route.path;
        this.$router.push(path);
      }
    },
    tomemberCenter() {
      this.$router.push({ path: "/memberCenter" });
    },
  },
};
</script>

<style lang="scss">
.user-info .el-dropdown-link {
  position: relative;
  display: inline-block;
  padding-left: 50px;
  cursor: pointer;
  vertical-align: middle;
  line-height: 3.125vw;
}
.user-info .user-logo {
  position: absolute;
  left: 0;
  top: 8%;
  height: 2.5vw;
  width: 2.5vw;
  border-radius: 50%;
}

a {
  color: #fff;
  text-decoration: none;
}

.navbar {
  height: 3.125vw;
  // background: linear-gradient(90deg, #f591a4, #fca138);
  background: #ffffff;
  // opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  padding-right: 3.5vw;

  .navbar-logo {
    height: 2.083vw;
    margin-left: 19.167vw;
  }

  .navbar-menus {
    list-style: none;
    display: flex;
    color: #696561;
    font-size: 1.042vw;
    font-weight: 400;
    padding-inline-start: 0;

    li {
      margin-left: 3.75vw;
      cursor: pointer;
    }

    // li:last-child {
    //   margin-right: 18.646vw;
    // }
  }
}

@media all and (max-width: 960px) {
  .navbar {
    height: 30px;

    .navbar-logo {
      height: 20px;
      margin-left: 183px;
    }

    .navbar-menus {
      font-size: 10px;

      li {
        margin-left: 32px;
      }
      li:last-child {
        margin-right: 179px;
      }
    }
  }
}
@media all and (min-width: 1920px) {
  .navbar {
    height: 60px;

    .navbar-logo {
      height: 40px;
      margin-left: 367px;
    }

    .navbar-menus {
      font-size: 20px;

      li {
        margin-left: 72px;
      }
      li:last-child {
        margin-right: 358px;
      }
    }
  }
}
</style>
